// NOTE: There is currently a bug in WLE with accessing material colors.
// Instead of getting an array of 4 elements for RGBA, only R is returned.
// Since this component relied on animating transparency, it's been switched
// to use a toggle instead, with the animation code commented out for now.
import anime from "animejs";

export let fader;

WL.registerComponent('fade', {
    fadeDuration: {type: WL.Type.Int, default: 300},
}, {
    init: function() {
        fader = this;
        this.material = this.object.getComponent('mesh').material;
        // this.currentFade = this.material.color[3];
        // this.color = new Float32Array(4);
        // this.color.set(this.material.color);
        this.mesh = this.object.getComponent('mesh'); 
    },
    fadeIn: function(delay, fadeOutAfter) {
        // if(this.currentAnim) return;
        this.mesh.active = true;
        // this.currentAnim = anime({
        //     targets: this,
        //     easing: "linear",
        //     currentFade: 1.0,
        //     delay: delay || 0,
        //     duration: this.fadeDuration,
        //     autoplay: false,
        //     update: (anim) => {
        //         this.color[3] = this.currentFade;
        //         this.material.color = this.color;
        //     },
        //     changeComplete: (anim) => {
        //         this.currentAnim = null;
        //         if(fadeOutAfter) {
        //             this.fadeOut(400);
        //         }
        //     }
        // });
        if (fadeOutAfter) {
            setTimeout(() => {
                this.fadeOut(400);
            }, delay);
        }
    },
    deathFadeIn: function(delay) {
        // if(this.currentAnim) return;
        this.mesh.active = true;
        // this.currentAnim = anime({
        //     targets: this,
        //     easing: "linear",
        //     currentFade: 0.6,
        //     delay: delay || 0,
        //     duration: this.fadeDuration,
        //     autoplay: false,
        //     update: (anim) => {
        //         this.color[3] = this.currentFade;
        //         this.material.color = this.color;
        //     },
        //     changeComplete: (anim) => {
        //         this.currentAnim = null;
        //         this.fadeOut(5000);
        //     }
        // });
        setTimeout(() => {
            this.fadeOut(5000);
        }, 300);
    },
    hitFadeIn: function() {
        // if(this.currentAnim) return;
        this.mesh.active = true;
        // this.currentAnim = anime({
        //     targets: this,
        //     easing: "linear",
        //     currentFade: 0.45,
        //     duration: 200,
        //     autoplay: false,
        //     update: (anim) => {
        //         this.color[3] = this.currentFade;
        //         this.material.color = this.color;
        //     },
        //     changeComplete: (anim) => {
        //         this.currentAnim = null;
        //         this.fadeOut(100);
        //     }
        // });
        setTimeout(() => {
            this.fadeOut(100);
        }, 200);
    },
    fadeOut: function(delay) {
        // if(this.currentAnim) return;
        // this.currentAnim = anime({
        //     targets: this,
        //     easing: "linear",
        //     currentFade: 0.0,
        //     delay: delay || 0,
        //     autoplay: false,
        //     duration: this.fadeDuration,
        //     update: (anim) => {
        //         this.color[3] = this.currentFade;
        //         this.material.color = this.color;
        //     },
        //     changeComplete: (anim) => {
        //         this.mesh.active = false;
        //         this.currentAnim = null;
        //     }
        // });
        setTimeout(() => {
            this.mesh.active = false;
        }, delay);
    },
    update: function(dt) {
        // if(this.currentAnim) {
        //     this.currentAnim.tick(getTime());
        // }
    }
});

function getTime() {
    const frame = Module.webxr_frame;
    return (frame && frame.predictedDisplayTime)
        || performance.now()
        || Date.now();
}